module.exports = __webpack_public_path__ + "img/img_pocket_star.84b8de57.png";